module.exports = __webpack_public_path__ + "static/tooltip1_4-16e018a3906b6a8dd78c1e7b7ec17180.png";